import { useMemo } from 'react'

import { formatSecondsToTime } from '@shared/uttils/formatSecondsToTime'

const useShopTime = (openTime: number, closeTime: number) => {
  const { open, close } = useMemo(() => {
    const open = formatSecondsToTime(openTime)
    const close = formatSecondsToTime(closeTime)
    return { open, close }
  }, [ openTime, closeTime ])

  const getShopStatus = useMemo(() => {
    const now = new Date()
    const currentTimeInSeconds = now.getHours() * 3600 + now.getMinutes() * 60
    return currentTimeInSeconds >= openTime && currentTimeInSeconds < closeTime
  }, [ openTime, closeTime ])

  return { open, close, getShopStatus }
}

export default useShopTime
